import { Chip, Fade, Typography } from '@material-ui/core'
import React from 'react'

import { PromotionCode } from '../../../graphql/promotions'
import { getTranslate, lang } from '../../../localization'
import useStyles from './styles/PromotionCodesTable.styles'

// Built at module scope, as PromotionRow does — one formatter per locale rather than one
// per row render.
const dateFormatter = new Intl.DateTimeFormat(
  lang === 'fa' ? 'fa-IR' : 'en-GB',
  { dateStyle: 'medium', timeStyle: 'short' }
)

const formatDate = (value?: string | null): string =>
  value ? dateFormatter.format(new Date(value)) : '—'

// available | reserved | consumed. Colour is NOT the only carrier — the label is the
// state, so the chip degrades to text for anyone who cannot distinguish the hues
// (WCAG 1.4.1). `default` for available is deliberate: an unused code is the resting
// state and should not compete for attention with the two that mean something happened.
const stateColour = (state: string): 'default' | 'primary' | 'secondary' => {
  if (state === 'consumed') return 'secondary'
  if (state === 'reserved') return 'primary'
  return 'default'
}

const PromotionCodeRow: React.FC<{ data: PromotionCode }> = ({ data }) => {
  const classes = useStyles()

  return (
    <Fade in timeout={600}>
      <div className={classes.tableRow}>
        {/*
          Each LTR token gets its OWN <bdi>. Wrapping a run of codes in one is not
          equivalent — the bidi algorithm reorders inside it, so a list renders reversed
          in RTL, silently becoming a different list. Only 4 screens in the portal do this
          correctly (conventions section 8.1).
        */}
        <div className={classes.cell} title={data.code}>
          <Typography variant="body1">
            <bdi>{data.code}</bdi>
          </Typography>
        </div>
        <div className={classes.cell} title={data.bookingId || undefined}>
          <Typography variant="body1">
            {/* An available code has no booking. An empty cell reads as missing data, so
                the em dash says "not applicable" rather than "unknown". */}
            {data.bookingId ? <bdi>{data.bookingId}</bdi> : '—'}
          </Typography>
        </div>
        <div className={classes.cell}>
          <Typography variant="body1">{formatDate(data.consumedAt)}</Typography>
        </div>
        <div>
          <Chip
            size="small"
            color={stateColour(data.state)}
            label={getTranslate(data.state)}
          />
        </div>
      </div>
    </Fade>
  )
}

export default PromotionCodeRow
